function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "tick");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "tick",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Tick",
  transform: "translate(5.000000, 11.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M25.5601001,-2.9916291 C26.642797,-2.99774093 27.525477,-2.12502242 27.5316527,-1.04232549 C27.5316527,-1.03766365 27.5316527,-1.03300174 27.5316527,-1.02833983 L27.4862768,30.064754 C27.4846822,31.1574901 26.6016834,32.044219 25.5089637,32.0504522 C24.4262668,32.056564 23.5435868,31.1838455 23.5374111,30.1011486 C23.5374111,30.0964868 23.5374111,30.0918248 23.5374111,30.0871629 L23.582787,-1.00593087 C23.5843816,-2.09866696 24.4673804,-2.98539591 25.5601001,-2.9916291 Z",
  id: "Rectangle",
  transform: "translate(25.534532, 14.529412) rotate(45.000000) translate(-25.534532, -14.529412) "
}), React.createElement("path", {
  d: "M8.87841476,10.8286972 L8.88686519,10.8286972 C9.98674699,10.8349486 10.8752326,11.7281028 10.875641,12.8280018 L10.8811855,27.7601588 C10.8815923,28.8562281 9.99338243,29.7450978 8.89731305,29.7455049 C8.89335485,29.7455049 8.88939666,29.7455049 8.88543852,29.7455049 L8.87698809,29.7455049 C7.77710629,29.7392536 6.88862063,28.8460994 6.88821224,27.7462004 L6.88266781,12.8140435 C6.88226098,11.7179741 7.77047085,10.8291044 8.86654023,10.8286972 C8.87049843,10.8286972 8.87445662,10.8286972 8.87841476,10.8286972 Z",
  id: "Rectangle",
  transform: "translate(8.881927, 20.287101) rotate(-45.000000) translate(-8.881927, -20.287101) "
})));

var SvgTick = function SvgTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick.aae35d00.svg";
export { ForwardRef as ReactComponent };